{
  "status": {
    "PROBATION": "Probation",
    "ACTIVE": "Active",
    "SUSPENDED": "Suspended",
    "ENDED": "Ended"
  },
  "listStatus": {
    "CURRENT": "Current staff",
    "ALL": "All statuses",
    "PROBATION": "On probation",
    "ACTIVE": "Active",
    "SUSPENDED": "Suspended",
    "ENDED": "Ended"
  },
  "nationalityClass": {
    "OMANI": "Omani",
    "NON_OMANI": "Non-Omani"
  },
  "nationality": {
    "common": "Common nationalities",
    "all": "All countries"
  },
  "gender": {
    "MALE": "Male",
    "FEMALE": "Female"
  },
  "marital": {
    "SINGLE": "Single",
    "MARRIED": "Married",
    "DIVORCED": "Divorced",
    "WIDOWED": "Widowed"
  },
  "payMethod": {
    "BANK": "Bank transfer (WPS)",
    "CASH": "Cash",
    "CHEQUE": "Cheque"
  },
  "contractType": {
    "UNLIMITED": "Unlimited",
    "FIXED_TERM": "Fixed term",
    "PART_TIME": "Part time",
    "TEMPORARY": "Temporary"
  },
  "endReason": {
    "RESIGNATION": "Resignation",
    "TERMINATION": "Termination",
    "END_OF_CONTRACT": "End of contract",
    "FAILED_PROBATION": "Did not pass probation",
    "RETIREMENT": "Retirement",
    "DEATH": "Death",
    "OTHER": "Other"
  },
  "salaryReason": {
    "HIRE": "Hiring",
    "INCREMENT": "Increment",
    "PROMOTION": "Promotion",
    "ADJUSTMENT": "Adjustment",
    "CORRECTION": "Correction"
  },
  "documentType": {
    "CIVIL_ID": "Civil ID",
    "RESIDENT_CARD": "Resident card",
    "PASSPORT": "Passport",
    "VISA": "Visa",
    "WORK_PERMIT": "Work permit",
    "DRIVING_LICENCE": "Driving licence",
    "HEALTH_CARD": "Health card",
    "CONTRACT": "Contract",
    "CERTIFICATE": "Certificate",
    "OTHER": "Other"
  },
  "documentStatus": {
    "ACTIVE": "Valid",
    "CANCELLED": "Cancelled"
  },
  "expiryBucket": {
    "EXPIRED": "Expired",
    "D7": "Due within 7 days",
    "D30": "Due within 30 days",
    "D90": "Due within 90 days"
  },
  "expiryWithin": {
    "EXPIRED": "Expired only",
    "D7": "Expired or due in 7 days",
    "D30": "Expired or due in 30 days",
    "D90": "Expired or due in 90 days"
  },
  "expiry": {
    "today": "Expires today",
    "in_one": "Expires in {{n}} day",
    "in_other": "Expires in {{n}} days",
    "ago_one": "Expired {{n}} day ago",
    "ago_other": "Expired {{n}} days ago"
  },
  "kind": {
    "EARNING": "Earning",
    "DEDUCTION": "Deduction"
  },
  "componentType": {
    "FIXED": "Fixed",
    "VARIABLE": "Variable"
  },
  "componentTypeHint": {
    "FIXED": "Part of the salary, paid every month.",
    "VARIABLE": "Entered on a payroll run when it applies (a bonus, an advance recovered)."
  },
  "dashboard": {
    "title": "Human resources",
    "subtitle": "The workforce today: who is employed, documents due and what ends soon",
    "links": {
      "employees": "Employees",
      "documents": "Document expiry"
    },
    "figures": "Workforce figures",
    "headcount": "Headcount",
    "headcountDetail": "Everyone not ended",
    "omani": "Omani",
    "omanisation": "Omanisation {{percent}}%",
    "nonOmani": "Non-Omani",
    "joiners": "Joined",
    "leavers": "Left",
    "thisMonth": "This month",
    "earnings": "Monthly earnings",
    "earningsDetail": "Current salaries, before deductions",
    "byStatus": "By status",
    "expiring": "Documents expiring",
    "expiringEmpty": "No document expires within 90 days.",
    "seeAll": "See all",
    "probation": "Probation ending within 30 days",
    "probationEmpty": "No probation ends soon.",
    "contractsEnding": "Fixed-term contracts ending within 60 days",
    "contractsEndingEmpty": "No fixed-term contract ends soon.",
    "byUnit": "By org unit",
    "noUnit": "No unit",
    "byNationality": "By nationality",
    "nobody": "No employees yet."
  },
  "setup": {
    "title": "Set up the salary structure first",
    "body": "Hiring needs the basic salary component. Load the standard Omani components (basic, housing, transport and the usual deductions) and adjust them as you need.",
    "bodyReader": "Hiring needs the basic salary component. Ask whoever sets up pay components to load them."
  },
  "employees": {
    "title": "Employees",
    "subtitle": "The employee file: staff, their jobs and their documents",
    "hire": "Hire employee",
    "searchPlaceholder": "Number, name or civil number",
    "searchLabel": "Search employees",
    "clearSearch": "Clear search",
    "documentsDue_one": "{{n}} document due",
    "documentsDue_other": "{{n}} documents due",
    "fields": {
      "number": "Number",
      "name": "Employee",
      "orgUnit": "Org unit",
      "nationality": "Nationality",
      "hireDate": "Hired",
      "documentsDue": "Documents",
      "monthlyGross": "Monthly gross",
      "status": "Status"
    },
    "filters": {
      "status": "Status",
      "nationality": "Nationality",
      "anyNationality": "Omani and non-Omani",
      "orgUnit": "Org unit",
      "allUnits": "All units"
    },
    "empty": {
      "title": "No employees yet",
      "body": "Hire the first employee to start the employee file.",
      "filteredTitle": "No employee matches",
      "filteredBody": "Change the search or the filters."
    }
  },
  "hire": {
    "title": "Hire employee",
    "subtitle": "The person, the job, the contract and the salary in one go",
    "submit": "Hire employee",
    "toast": "{{name}} hired as {{number}}"
  },
  "edit": {
    "title": "Edit employee",
    "submit": "Save changes",
    "toast": "{{name}} saved"
  },
  "form": {
    "sections": {
      "personal": "Personal details",
      "contact": "Contact",
      "job": "Job",
      "contract": "Contract",
      "salary": "Salary",
      "bank": "How the salary is paid"
    },
    "firstName": "First name",
    "middleName": "Middle name",
    "lastName": "Last name",
    "nameAr": "Full name in Arabic",
    "nameArHint": "As on the civil ID or resident card.",
    "gender": "Gender",
    "birthDate": "Date of birth",
    "maritalStatus": "Marital status",
    "notGiven": "Not given",
    "nationality": "Nationality",
    "nationalityPlaceholder": "Choose a nationality",
    "nationalitySearch": "Search countries",
    "nationalityEmpty": "No country found",
    "civilNumber": "Civil ID / resident card number",
    "civilNumberHint": "The WPS salary file identifies the employee by it.",
    "passportNumber": "Passport number",
    "spfNumber": "Social Protection Fund number",
    "spfNumberHint": "The insurance number, for Omani employees.",
    "spfExempt": "Exempt from social contributions",
    "spfExemptHint": "No contribution rule applies (for example a re-employed pensioner).",
    "email": "E-mail",
    "phone": "Phone",
    "address": "Address",
    "emergencyName": "Emergency contact",
    "emergencyPhone": "Emergency contact phone",
    "jobTitle": "Job title",
    "jobTitleAr": "Job title in Arabic",
    "orgUnit": "Org unit",
    "orgUnitPlaceholder": "Choose an org unit",
    "noUnit": "No unit",
    "hireDate": "Hire date",
    "hireDateHint": "The first working day: the contract, the salary and the service start on it.",
    "salaryHint": "The monthly amount of each fixed component. The basic salary is required.",
    "bankHint": "The bank and IBAN go in the WPS salary file.",
    "payMethod": "Pay method",
    "bankCode": "Bank code",
    "bankCodeHint": "The bank’s short code or BIC, e.g. BMUSOMRX.",
    "iban": "IBAN or account number",
    "choose": "Choose…",
    "fix": "Some fields need attention.",
    "notSaved": "Not saved",
    "user": "System login",
    "userHint": "Links what the user earns (commission, incentives) to this employee’s payroll.",
    "noUser": "No login"
  },
  "contract": {
    "type": "Contract type",
    "startDate": "Starts on",
    "endDate": "Ends on",
    "endDateFixed": "A fixed-term contract needs its end date.",
    "endDateHint": "Leave empty for an open-ended contract.",
    "probationMonths": "Probation (months)",
    "probationHint": "Three months by default, at most {{max}}.",
    "probationUntil": "{{months}} months, until {{date}}",
    "noticeDays": "Notice (days)",
    "weeklyHours": "Hours a week",
    "note": "Note",
    "currentTitle": "Current contract",
    "none": "No contract on file.",
    "openEnded": "Open-ended",
    "newVersion": "New contract version",
    "newTitle": "New contract version",
    "newBody": "The current contract is kept as it was and superseded from the new start date.",
    "newConfirm": "Save new version",
    "toast": "New contract version saved",
    "versions": "Contract versions",
    "version": "Version",
    "current": "Current",
    "period": "Period"
  },
  "salary": {
    "currentTitle": "Current salary",
    "since": "In force since {{date}}",
    "none": "No salary on file.",
    "change": "Change salary",
    "changeTitle": "Change salary",
    "changeBody": "A new salary from a date; earlier salaries stay as they were and payroll prorates across them.",
    "changeConfirm": "Save new salary",
    "toast": "New salary saved",
    "effectiveFrom": "Effective from",
    "reason": "Reason",
    "note": "Note",
    "history": "Salary history",
    "current": "Current",
    "by": "Recorded by",
    "component": "Component",
    "amount": "Amount a month",
    "totalEarnings": "Total earnings",
    "totalDeductions": "Total deductions",
    "noBasicTitle": "No basic salary component",
    "noBasicBody": "A salary needs the basic salary component. Load the standard components in Pay components first.",
    "openComponents": "Open pay components"
  },
  "employee": {
    "title": "Employee",
    "backToList": "Back to employees",
    "since": "Since {{date}} · {{years}} years of service",
    "probationEnds": "Probation ends {{date}}",
    "suspendedTitle": "Suspended: payroll does not pay this employee while suspended",
    "endedTitle": "Employment ended on {{date}} ({{reason}})",
    "actions": {
      "confirmProbation": "Confirm probation",
      "reinstate": "Reinstate",
      "edit": "Edit",
      "suspend": "Suspend",
      "end": "End employment"
    }
  },
  "tabs": {
    "label": "Employee file",
    "overview": "Overview",
    "contract": "Contract",
    "salary": "Salary",
    "documents": "Documents",
    "files": "Files",
    "payslips": "Payslips",
    "history": "History"
  },
  "overview": {
    "nameEn": "Name in English",
    "spfExempt": "Exempt from social contributions",
    "serviceYears": "Service",
    "years": "{{years}} years",
    "probationEnd": "Probation ends",
    "yes": "Yes",
    "no": "No"
  },
  "confirmProbation": {
    "title": "Confirm {{name}} after probation?",
    "body": "The employee becomes active and the probation period closes.",
    "confirm": "Confirm probation",
    "toast": "{{name}} confirmed"
  },
  "reinstate": {
    "title": "Reinstate {{name}}?",
    "body": "The suspension ends and payroll pays the employee again.",
    "confirm": "Reinstate",
    "toast": "{{name}} reinstated"
  },
  "suspend": {
    "title": "Suspend {{name}}",
    "body": "While suspended the employee is not paid. Their file and documents are kept.",
    "reason": "Reason",
    "confirm": "Suspend",
    "toast": "{{name}} suspended"
  },
  "end": {
    "title": "End the employment of {{name}}",
    "body": "Payroll pays up to the last working day and settles the end of service in its month.",
    "endedOn": "Last working day",
    "endedOnHint": "Payroll pays up to this day.",
    "reason": "Reason",
    "note": "Note",
    "confirm": "End employment",
    "toast": "The employment of {{name}} ended"
  },
  "documents": {
    "add": "Add document",
    "addTitle": "Add document",
    "edit": "Edit",
    "editTitle": "Edit document",
    "save": "Save document",
    "cancel": "Cancel document",
    "cancelTitle": "Cancel this document?",
    "cancelBody": "A cancelled document no longer counts for expiry. It stays on file and cannot change.",
    "cancelConfirm": "Cancel document",
    "toastAdded": "Document added",
    "toastSaved": "Document saved",
    "toastCancelled": "Document cancelled",
    "empty": "No documents on file.",
    "actionsFor": "Actions for {{type}}",
    "fields": {
      "type": "Document",
      "number": "Number",
      "issuedOn": "Issued on",
      "expiresOn": "Expires on",
      "issuedBy": "Issued by",
      "note": "Note",
      "status": "Status"
    }
  },
  "payslips": {
    "period": "Month",
    "status": "Run status",
    "paidDays": "Paid days",
    "gross": "Gross",
    "deductions": "Deductions",
    "net": "Net pay",
    "empty": "No payslips yet."
  },
  "history": {
    "effectiveOn": "Effective",
    "change": "Change",
    "to": "to",
    "reason": "Reason",
    "by": "By",
    "system": "System",
    "empty": "No status changes yet."
  },
  "expiryPage": {
    "title": "Document expiry",
    "subtitle": "Current employees’ documents expired or due, soonest first",
    "searchPlaceholder": "Employee or document number",
    "searchLabel": "Search documents",
    "fields": {
      "employee": "Employee"
    },
    "filters": {
      "within": "Expiry",
      "type": "Document",
      "allTypes": "All documents"
    },
    "empty": {
      "title": "Nothing expiring",
      "body": "No document is expired or due in this window."
    }
  },
  "components": {
    "title": "Pay components",
    "subtitle": "The salary structure: what salaries and payroll runs are made of",
    "add": "Add component",
    "addTitle": "Add pay component",
    "edit": "Edit",
    "editTitle": "Edit {{code}}",
    "save": "Save component",
    "archive": "Archive",
    "restore": "Restore",
    "archived": "Archived",
    "active": "In use",
    "inUse": "On a salary or run",
    "showArchived": "Show archived components",
    "loadStandard": "Load standard components",
    "loadedToast_one": "{{n}} component loaded",
    "loadedToast_other": "{{n}} components loaded",
    "addedToast": "{{code}} added",
    "savedToast": "{{code}} saved",
    "archivedToast": "{{code}} archived",
    "restoredToast": "{{code}} restored",
    "actionsFor": "Actions for {{code}}",
    "systemReason": "The basic salary cannot be archived.",
    "systemNote": "The basic salary keeps its code and stays fixed: contributions, overtime and gratuity are priced on it.",
    "inUseNote": "This component is on a salary or a run: its code and kind can no longer change.",
    "defaultEarningAccount": "Salaries and wages (default)",
    "defaultDeductionAccount": "Payroll deductions payable (default)",
    "defaultAccount": "The default account",
    "accountHintEarning": "Empty: earnings post to salaries and wages.",
    "accountHintDeduction": "Empty: deductions post to payroll deductions payable.",
    "accountSearch": "Search accounts",
    "accountEmpty": "No account found",
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameEn": "Name in English",
      "nameAr": "Name in Arabic",
      "kind": "Kind",
      "type": "Type",
      "flags": "Counts in",
      "account": "Account",
      "sortOrder": "Order",
      "status": "Status"
    },
    "flags": {
      "spf": "Contribution wage",
      "spfHint": "Counts in the wage the social protection rules apply to.",
      "gratuity": "Gratuity wage",
      "gratuityHint": "Counts in the wage end-of-service gratuity is priced on (by law the basic).",
      "prorated": "Prorated",
      "proratedHint": "Paid for the days worked in a month of joining or leaving, and reduced by unpaid days."
    },
    "empty": {
      "title": "No pay components yet",
      "body": "Load the standard Omani components, then adjust them."
    }
  },
  "picker": {
    "placeholder": "Choose an employee",
    "search": "Number, name or civil number",
    "empty": "No employee found",
    "error": "The employees could not be loaded"
  },
  "validation": {
    "nationality": "Choose a nationality",
    "hours": "Enter hours with up to 2 decimals",
    "fixedTermEnd": "A fixed-term contract needs an end date",
    "endBeforeStart": "Ends before it starts",
    "positive": "Must be more than zero",
    "basicRequired": "Enter the basic salary",
    "listedTwice": "Listed twice",
    "reason": "Choose a reason",
    "expiresBeforeIssued": "Expires before it was issued",
    "componentCode": "Use 2–30 letters, digits or underscores, starting with a letter"
  },
  "errors": {
    "EMPLOYEE_CIVIL_NUMBER_TAKEN": "Another current employee has this civil number.",
    "EMPLOYEE_STATUS": "This cannot be done in the employee’s current status. Reload the page to see it.",
    "EMPLOYEE_DATE_INVALID": "This date does not fit: it is before the hire date, too far ahead or in a month already paid.",
    "SALARY_DATE_TAKEN": "Another salary already starts on this date. Choose another date.",
    "BASIC_REQUIRED": "A salary needs the basic salary. Load the standard pay components first.",
    "PAY_COMPONENT_NOT_USABLE": "One of the components is archived, or variable (variable components go on a payroll run, not a salary).",
    "PAY_COMPONENT_CODE_TAKEN": "Another component has this code.",
    "PAY_COMPONENT_SYSTEM": "The basic salary cannot be archived, recoded or made variable.",
    "PAY_COMPONENT_IN_USE": "This component is on a salary or a run: its code and kind cannot change.",
    "DOCUMENT_CANCELLED": "A cancelled document cannot change.",
    "ORG_UNIT_REQUIRED": "Your access covers part of the employees: choose an org unit within it.",
    "ORG_UNIT_OUT_OF_SCOPE": "This org unit is outside the units your access covers. Choose one of your units.",
    "EMPLOYEE_USER_TAKEN": "Another employee already has this system login."
  }
}
